import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal, ModalTypes } from '@eika/modal';
const UsTaxRelationsToggleHelpModal = _ref => {
  let {
    className
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const showModal = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    className: className,
    onClick: showModal,
    icon: IconTypes.INFO_20,
    id: "help-icon-overall-tax-relations",
    screenReaderText: "Hjelpetekst"
  }), /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    show: isModalOpen,
    id: "helpermodal__modal",
    type: ModalTypes.STANDARD,
    appNamespace: "kyc-declaration.app"
  }, /*#__PURE__*/React.createElement("div", {
    role: "tooltip",
    id: "helpermodal"
  }, /*#__PURE__*/React.createElement("p", null, "Man regnes som skattepliktig til USA dersom man:"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Er amerikansk statsborger inkludert dobbelt statsborgerskap"), /*#__PURE__*/React.createElement("li", null, "Er f\xF8dt eller bosatt i USA"), /*#__PURE__*/React.createElement("li", null, "Har gyldig oppholds- eller arbeidstillatelse (Green Card) i USA")), /*#__PURE__*/React.createElement(StandardButton, {
    className: "help-modal-button",
    onClick: closeModal
  }, "Lukk"))));
};
export default UsTaxRelationsToggleHelpModal;